<template>
  <listview :vm="listVm" />
</template>

<script>
  import Listview from '@/components/base/Listview';
  import ListVm from '@/components/base/ListVm';
  import Router from '@/router';
  import Format from '@/format';
  
  const _comp = {
    name: 'Creditnotas',
    data: () => ({
      listVm: null
    }),
    created() {
      this.listVm = new ListVm(
        'Creditnota\'s',
        'No',
        (ctx) => `/odata/PostedSalesCreditMemo?$filter=Posting_Date ge ${ctx.year}-01-01T00:00:00Z and Posting_Date le ${ctx.year}-12-31T23:59:59Z`,
        ['Due_Date', 'Posting_Date'],
        (srch, items) => items.filter(i => `${i.No}${i.Return_Order_No}${i.Order_No}${i.Your_Reference}${i.External_Document_No}`.toLowerCase().indexOf(srch.toLowerCase()) != -1),
        (item) => Router.push('/Creditnota/' + item.No),
        [
          { name: 'Nr.', sort: 'No', select: i => i.No },
          { name: 'Orderklantnr.', sort: 'Bill_to_Customer_No', select: i => i.Bill_to_Customer_No },
          { name: 'Naam', sort: 'Bill_to_Name', select: i => i.Bill_to_Name },
          { name: 'Ordernr.', sort: 'Return_Order_No', select: i => i.Return_Order_No },
          { name: 'Boekingsdatum', sort: 'Posting_Date', select: i => Format.date(i.Posting_Date) },
          { name: 'Ordernummer', sort: 'Order_No', select: i => i.Order_No },
/////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////
////////////////////
          { name: 'Extern documentnr', sort: 'External_Document_No', select: i => i.External_Document_No },
        ]
      );
    },
    components: {
      'listview': Listview
    }
  };

  export default _comp;
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Creditnotas.vue